import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_7 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_10 = {
  key: 1,
  class: "text-info"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "text-nowrap" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { style: {"word-wrap":"break-word","width":"50%"} }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_25 = { class: "dropdown" }
const _hoisted_26 = { class: "dropdown-menu" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center" }
const _hoisted_30 = { class: "mb-0 text-paragraph" }
const _hoisted_31 = { class: "fw-bold" }
const _hoisted_32 = { class: "fw-bold" }
const _hoisted_33 = { class: "fw-bold" }
const _hoisted_34 = { class: "mt-15 mt-md-0" }
const _hoisted_35 = { class: "pagination mb-0" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_38 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_39 = { class: "modal-content p-15 p-md-40" }
const _hoisted_40 = { class: "modal-body" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-md-4" }
const _hoisted_43 = { class: "form-group mb-3" }
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = { class: "form-group mb-3" }
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = { class: "form-group mb-3" }
const _hoisted_48 = { class: "col-md-4" }
const _hoisted_49 = { class: "form-group mb-3" }
const _hoisted_50 = { class: "modal-footer" }
const _hoisted_51 = {
  class: "modal fade",
  id: "detailColisModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_52 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_53 = { class: "modal-content p-15 p-md-40" }
const _hoisted_54 = { class: "modal-body" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-md-6" }
const _hoisted_57 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_58 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_59 = { class: "list-unstyled my-1" }
const _hoisted_60 = { class: "align-middle" }
const _hoisted_61 = { class: "my-25" }
const _hoisted_62 = { class: "align-middle" }
const _hoisted_63 = { class: "align-middle" }
const _hoisted_64 = { class: "align-middle" }
const _hoisted_65 = { class: "col-md-6" }
const _hoisted_66 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_67 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_68 = { class: "list-unstyled my-1" }
const _hoisted_69 = { class: "align-middle" }
const _hoisted_70 = { class: "my-25" }
const _hoisted_71 = { class: "align-middle" }
const _hoisted_72 = { class: "my-25" }
const _hoisted_73 = { class: "align-middle" }
const _hoisted_74 = { class: "my-25" }
const _hoisted_75 = { class: "align-middle" }
const _hoisted_76 = { class: "my-25" }
const _hoisted_77 = { class: "align-middle" }
const _hoisted_78 = { class: "my-25" }
const _hoisted_79 = { class: "align-middle" }
const _hoisted_80 = { class: "my-25" }
const _hoisted_81 = { class: "align-middle" }
const _hoisted_82 = { class: "align-middle" }
const _hoisted_83 = { class: "align-middle" }
const _hoisted_84 = { class: "table table-sm table-bordered mt-20" }
const _hoisted_85 = { class: "td-nowrap" }
const _hoisted_86 = ["src"]
const _hoisted_87 = ["src"]
const _hoisted_88 = { class: "parcel-status td-nowrap" }
const _hoisted_89 = {
  key: 1,
  class: "dn-inv-table-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher",
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getRecords())),
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getRecords && _ctx.getRecords(...args))),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.searchTerm) = $event))
          }, null, 544), [
            [_vModelText, _ctx.filter.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _cache[28] || (_cache[28] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                }, " Code d'envoi "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Destinataire "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Magasin "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Status "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Ville "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Prix "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Date de création "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Produits "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " ACTIONS ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("th", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (row.replace === 1)
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_9, [
                            _createTextVNode(_toDisplayString(row.code) + " ", 1),
                            _cache[12] || (_cache[12] = _createElementVNode("i", { class: "ph ph-repeat" }, null, -1))
                          ]))
                        : (row.partial === 1)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_10, [
                              _createTextVNode(_toDisplayString(row.code) + " ", 1),
                              _cache[13] || (_cache[13] = _createElementVNode("i", { class: "ph ph-arrows-down-up" }, null, -1))
                            ]))
                          : (_openBlock(), _createElementBlock("h6", _hoisted_11, _toDisplayString(row.code), 1))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, [
                      _createElementVNode("b", null, _toDisplayString(row.receiver), 1),
                      _cache[14] || (_cache[14] = _createTextVNode()),
                      _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("b", null, _toDisplayString(_ctx.oldPhone(row.phone)), 1),
                      _cache[16] || (_cache[16] = _createTextVNode()),
                      _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_14, [
                    (row.magasin_name)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_15, "Magasin : " + _toDisplayString(row.magasin_name), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createTextVNode(_toDisplayString(row.customer_name), 1),
                          _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.oldPhone(row.customer_phone)), 1)
                        ]))
                  ]),
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("div", {
                      class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                      style: _normalizeStyle({ '--dynamic-bg': _ctx.getBadgeConfig(row).color })
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).text) + " ", 1),
                      (_ctx.getBadgeConfig(row).date)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).date), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.getBadgeConfig(row).comment)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).comment), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 4)
                  ]),
                  _createElementVNode("td", _hoisted_18, [
                    _createElementVNode("b", null, _toDisplayString(row.city_name), 1),
                    _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                    (row.quartier && row.quartier.name)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(row.quartier.name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("b", null, _toDisplayString(row.price), 1),
                    _cache[22] || (_cache[22] = _createTextVNode("Dhs", -1)),
                    _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("p", _hoisted_21, _toDisplayString(row.product_nature), 1)
                  ]),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.getDate(row.created_at)), 1),
                  _createElementVNode("td", _hoisted_23, [
                    _createElementVNode("b", null, _toDisplayString(row.nb_pros || 0), 1),
                    _cache[24] || (_cache[24] = _createTextVNode(" Produits ", -1))
                  ]),
                  _createElementVNode("td", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _cache[27] || (_cache[27] = _createElementVNode("button", {
                        class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                        type: "button",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createElementVNode("i", { class: "flaticon-dots" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_26, [
                        _createElementVNode("li", null, [
                          _createElementVNode("button", {
                            class: "dropdown-item d-flex align-items-center",
                            onClick: ($event: any) => (_ctx.showDetails(row))
                          }, _cache[25] || (_cache[25] = [
                            _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Infos ", -1)
                          ]), 8, _hoisted_27)
                        ]),
                        _createElementVNode("li", null, [
                          (_ctx.auth.can('STOCK'))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.removeColis(row))
                              }, _cache[26] || (_cache[26] = [
                                _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" supprimer", -1)
                              ]), 8, _hoisted_28))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("p", _hoisted_30, [
            _cache[29] || (_cache[29] = _createTextVNode(" Showing ", -1)),
            _createElementVNode("span", _hoisted_31, _toDisplayString((_ctx.filter.current_page - 1) * _ctx.filter.per_page + 1), 1),
            _cache[30] || (_cache[30] = _createTextVNode(" – ", -1)),
            _createElementVNode("span", _hoisted_32, _toDisplayString(Math.min(_ctx.filter.current_page * _ctx.filter.per_page, _ctx.filter.total)), 1),
            _cache[31] || (_cache[31] = _createTextVNode(" out of ", -1)),
            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.filter.total), 1),
            _cache[32] || (_cache[32] = _createTextVNode(" results ", -1))
          ]),
          _createElementVNode("nav", _hoisted_34, [
            _createElementVNode("ul", _hoisted_35, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.filter.current_page === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "javascript:void(0)",
                  "aria-label": "Previous",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page - 1)))
                }, _cache[33] || (_cache[33] = [
                  _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                ]))
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filter.last_page, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  class: "page-item"
                }, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: _normalizeClass(["page-link", { active: _ctx.filter.current_page === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_36)
                ]))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.filter.current_page === _ctx.filter.last_page }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "javascript:void(0)",
                  "aria-label": "Next",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page + 1)))
                }, _cache[34] || (_cache[34] = [
                  _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                ]))
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _cache[40] || (_cache[40] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Filtrer"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("form", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _cache[35] || (_cache[35] = _createElementVNode("label", null, "Magasin:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.client_filter,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.client_filter) = $event)),
                    label: "name",
                    options: _ctx.clientList,
                    onSearch: _ctx.filterClients
                  }, null, 8, ["modelValue", "options", "onSearch"])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", null, "Zone:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.zone_filter,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.zone_filter) = $event)),
                    label: "name",
                    options: _ctx.zonesList
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", null, "Ville:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.city_filter,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.city_filter) = $event)),
                    label: "name",
                    options: _ctx.citiesList
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _cache[38] || (_cache[38] = _createElementVNode("label", null, "Status:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.status_filter,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.status_filter) = $event)),
                    style: {"border-color":"#0000002b"},
                    label: "name",
                    options: _ctx.status
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _cache[39] || (_cache[39] = _createElementVNode("div", { class: "col-md-4" }, [
                _createElementVNode("div", { class: "form-group mb-3" }, [
                  _createElementVNode("label", null, "Par Date:")
                ])
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.filterList && _ctx.filterList(...args))),
              class: "btn btn-primary"
            }, " Annuler "),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.removeFilter && _ctx.removeFilter(...args))),
              class: "btn btn-warning"
            }, " Appliquer ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _cache[61] || (_cache[61] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Informations colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _cache[45] || (_cache[45] = _createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
                    _createElementVNode("h5", { class: "mb-0" }, "Informarion Colis :")
                  ], -1)),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("ul", _hoisted_59, [
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_60, [
                          _cache[41] || (_cache[41] = _createElementVNode("b", { class: "bclass" }, "Store :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.magasin_name), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_61, [
                        _createElementVNode("span", _hoisted_62, [
                          _cache[42] || (_cache[42] = _createElementVNode("b", { class: "bclass" }, "Téléphone : ", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.magasin?.phone_store), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_63, [
                          _cache[43] || (_cache[43] = _createElementVNode("b", { class: "bclass" }, "Client :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.store), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_64, [
                          _cache[44] || (_cache[44] = _createElementVNode("b", { class: "bclass" }, "Responsable :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.customer_name), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _cache[55] || (_cache[55] = _createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
                    _createElementVNode("h5", { class: "mb-0" }, "Information Bon livraison")
                  ], -1)),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("ul", _hoisted_68, [
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_69, [
                          _cache[46] || (_cache[46] = _createElementVNode("b", { class: "bclass" }, "Code d'envoie :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.code), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_70, [
                        _createElementVNode("span", _hoisted_71, [
                          _cache[47] || (_cache[47] = _createElementVNode("b", { class: "bclass" }, "Destinataire :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.receiver), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_72, [
                        _createElementVNode("span", _hoisted_73, [
                          _cache[48] || (_cache[48] = _createElementVNode("b", { class: "bclass" }, "Téléphone :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.phone), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_74, [
                        _createElementVNode("span", _hoisted_75, [
                          _cache[49] || (_cache[49] = _createElementVNode("b", { class: "bclass" }, "Ville :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.city_name), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_76, [
                        _createElementVNode("span", _hoisted_77, [
                          _cache[50] || (_cache[50] = _createElementVNode("b", { class: "bclass" }, "Adresse :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.address), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_78, [
                        _createElementVNode("span", _hoisted_79, [
                          _cache[51] || (_cache[51] = _createElementVNode("b", { class: "bclass" }, "Commentaire :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.note), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_80, [
                        _createElementVNode("span", _hoisted_81, [
                          _cache[52] || (_cache[52] = _createElementVNode("b", { class: "bclass" }, "Quartier :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.quartier), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_82, [
                          _cache[53] || (_cache[53] = _createElementVNode("b", { class: "bclass" }, "Nature Produit :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.product_nature), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_83, [
                          _cache[54] || (_cache[54] = _createElementVNode("b", { class: "bclass" }, "Crbt :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.price) + " DH", 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _cache[60] || (_cache[60] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("table", _hoisted_84, [
              _cache[59] || (_cache[59] = _createElementVNode("thead", null, [
                _createElementVNode("tr", { class: "dn-inv-table-head" }, [
                  _createElementVNode("th", null, "Photo"),
                  _createElementVNode("th", null, "Nom du produit"),
                  _createElementVNode("th", null, "Quantité")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_ctx.colisContents.length != 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.colisContents, (prod, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "dn-inv-table-body",
                        key: index
                      }, [
                        _createElementVNode("td", _hoisted_85, [
                          (prod.product_pic && prod.product_pic != null)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                height: "50",
                                width: "50",
                                src: prod.product_pic
                              }, null, 8, _hoisted_86))
                            : (prod.product_pic == null)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  height: "50",
                                  width: "50",
                                  src: require('@/assets/images/NoImage.png')
                                }, null, 8, _hoisted_87))
                              : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_88, [
                          _createElementVNode("b", null, _toDisplayString(prod.product_name), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("b", null, _toDisplayString(prod.qnty) + " : ", 1),
                          _createTextVNode(" " + _toDisplayString(prod.variant_name), 1),
                          _cache[56] || (_cache[56] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" " + _toDisplayString(prod.product_name), 1),
                          _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1))
                        ])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("tr", _hoisted_89, _cache[58] || (_cache[58] = [
                      _createElementVNode("td", {
                        colspan: "8",
                        style: {"text-align":"center"}
                      }, " Aucun produit trouvé. ", -1)
                    ])))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}